/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarnumber_Acht3Inputs */

const nl_enums_leerjaarnumber_acht3 = /** @type {(inputs: Enums_Leerjaarnumber_Acht3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8`)
};

/**

* @param {Enums_Leerjaarnumber_Acht3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarnumber_acht3 = /** @type {((inputs?: Enums_Leerjaarnumber_Acht3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarnumber_Acht3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarnumber_acht3(inputs)
});
export { enums_leerjaarnumber_acht3 as "enums.LeerjaarNumber.Acht" }